import { useParams } from 'react-router-dom'

import { ResidentAppError } from '../../../common/error'

export const useCurrentFeedbackNotice = () => {
  const { feedbackQuestionNoticeUuid } = useParams()

  if (!feedbackQuestionNoticeUuid) {
    throw ResidentAppError.ClientError('NOT_FOUND', {
      message: 'No feedbackQuestionNoticeUuid found in params',
    })
  }

  return {
    currentFeedbackNoticeUuid: feedbackQuestionNoticeUuid,
  }
}
